import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { HeadingText, BodyText, CaptionText } from '@paypalcorp/pp-react'
import { psTextCss, headerTextCss } from '../style'
import { TEXT_TYPES } from '@/constants/personalization-studio'

function PsText({ text = '', font = '', textWithButton = false, cssProps = {}, ariaLabel = '' }) {
  const { HEADING, BODY, CAPTION } = TEXT_TYPES
  const { bodyTextCss, headerTextCss: headerTextCssOverride } = cssProps

  if (text) {
    switch (font) {
      case HEADING:
        return (
          <HeadingText
            data-testid="ps-text-heading"
            level={2}
            css={css([headerTextCss, headerTextCssOverride])}
            align="center"
            aria-label={ariaLabel}
          >
            <span dangerouslySetInnerHTML={{ __html: text }} aria-hidden={ariaLabel ? 'true' : undefined} />
          </HeadingText>
        )
      case BODY:
        return (
          <BodyText
            data-testid="ps-text-body"
            css={css([psTextCss({ textWithButton }), bodyTextCss])}
            aria-label={ariaLabel}
          >
            <span dangerouslySetInnerHTML={{ __html: text }} aria-hidden={ariaLabel ? 'true' : undefined} />
          </BodyText>
        )
      case CAPTION:
        return (
          <CaptionText
            data-testid="ps-text-caption"
            css={psTextCss}
            aria-label={ariaLabel}
          >

            <span dangerouslySetInnerHTML={{ __html: text }} aria-hidden={ariaLabel ? 'true' : undefined} />
          </CaptionText>
        )
      default:
        return null
    }
  }
}

PsText.propTypes = {
  text: PropTypes.string,
  font: PropTypes.string,
  textWithButton: PropTypes.bool,
  cssProps: PropTypes.object,
  ariaLabel: PropTypes.string,
}

export default PsText
